// extracted by mini-css-extract-plugin
export default {"messageAndSearchbar":"SchoolPages_messageAndSearchbar__HSkqG","divider":"SchoolPages_divider__FM+F5"};